export const environment = {
  production: true,
  qualys: false,
  googleMapsApiKey: 'AIzaSyDVvlMjZlNzR_b6h-rDxue-WIKgpyc8x9s',
  apiUrl: 'https://de-dev-backend-insp-b6h362l2za-uc.a.run.app/',
  endpoint: {
    directLogging: 'v2/directLogging',
    getFile: 'getFile',
    getTask: 'getTask',
    getOrgTemplateHelp: 'getOrgTemplateHelp',
    getTaskProperties: 'getTaskProperties',
    getZoneMaster: 'getZoneMaster',
    taskAddressVerification: 'taskAddressVerification',
    getWhiteLabelAssets: 'getWhiteLabelAssets',
    addTaskTemplate: 'addTaskTemplate',
    getStatusDetailsJson: 'getStatusDetailsJson',
    getTaskTemplate: 'getTaskTemplate',
    getFileMetaData: 'getFileMetaData',
    getTaskMasterLOV: 'getTaskMasterLOV',
    verifyInspectionURL: 'verifyInspectionURL',
    verifyOtp: 'v2/verifyOtp',
    fileMeteDataUpload: 'fileMeteDataUpload',
    getFNOLDataTemplate: 'getFNOLDataTemplate',
    getTaskStatusDetails: 'getTaskStatusDetails',
    deleteMediaDetails: 'deleteMediaDetails',
    fileUpload: 'fileUpload',
    getTaskReport: 'getTaskReport',
    getTaskAddress: 'v2/getTaskAddress',
    getBusDocTskConfig: 'getBusDocTskConfig',
    fetchExternalApiInput: 'fetchExternalApiInput',
    getRefreshToken: 'getRefreshToken',
    getOrgTemplate: 'getOrgTemplate',
    generateReportAiSummary: 'generateReportAiSummary',
    fetchExternalApiData: 'fetchExternalApiData',
    createTaskUserActivity: 'createTaskUserActivity'
  },
};
